import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@mui/material/Input";
// Icons
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import Projectcolors from "../Utils/Colors";
import { Alert ,Typography} from "@mui/material";
import { baseURL } from "../Config/config";
import Checkbox from "@mui/material/Checkbox";
import GlobalLoader from "./CommonC/GlobalLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
    height: 15,
  },
  selectTableCell: {
    width: 60,
  },
  tableCell: {
    width: 180,
    height: 2,
    fontSize: 13,
  },
  input: {
    width: 130,
    height: 40,
    fontSize: 13,
  },
}));

const createData = (tagname, lower, upper) => ({
  tagname: tagname,
  lower,
  upper,
  isEditMode: false,
});

const CustomTableCell = ({ row, name, onChange }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell
      sx={{ fontSize: "12px" }}
      align="left"
      className={classes.tableCell}
    >
      {isEditMode ? (
        <Input
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row)}
          className={classes.input}
          sx={{ fontSize: "12px" }}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

function Limit(props) {
  const [rows, setRows] = React.useState([]);
  const [previous, setPrevious] = React.useState({});
  const [saved, setsaved] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);

  const classes = useStyles();

  React.useEffect(() => {
    getLimitData();
  }, []);
  const getLimitData = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getlimitdata?projectID=${ProjectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((myresponse) => {
        setRows(myresponse.data);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
      });
  };

  const onToggleEditMode = (tagname) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.tagname === tagname) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onChange = (e, row) => {
    if (!previous[row.tagname]) {
      setPrevious((state) => ({ ...state, [row.tagname]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { tagname } = row;
    const newRows = rows.map((row) => {
      if (row.tagname === tagname) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onRevert = (tagname) => {
    const newRows = rows.map((row) => {
      if (row.tagname === tagname) {
        return previous[tagname] ? previous[tagname] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[tagname];
      return state;
    });
    onToggleEditMode(tagname);
  };

  const handlestatuslimit = (e) => {
    const newData = rows.map((row, i) => {
      if (i === parseInt(e.target.value)) {
        const newstatus = row.status === false ? true : false;

        return { ...row, status: newstatus };
      }
      return row;
    });
    setRows(newData);
  };

  const savelimits = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");

    const body = {
      rows: rows,
      ProjectID: ProjectID,
    };

    fetch(`${baseURL}/savelimits`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        setGetLoader(false);
        setsaved(true);
      })
      .catch((error) => {
        setGetLoader(false);
        console.error("Error:", error);
      });
  };

 return (
  <Box sx={{ px: 2, py: 2 }}>

    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "22px",
        bgcolor: "#fff",
        boxShadow:
          "0px 8px 30px rgba(0,0,0,.06)"
      }}
    >

      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#0078c9",
          mb: 2
        }}
      >
        Engineering Constraints
      </Typography>

      <TableContainer
        sx={{
          height: 450,
          borderRadius: "14px",
          overflow: "auto",
          border:
            "1px solid rgba(0,120,201,.15)"
        }}
      >
        <Table stickyHeader>

          <TableHead>

            <TableRow>

              {[
                "",
                "Tag Name",
                "Description",
                "",
                "Lower Limit",
                "Upper Limit"
              ].map((item) => (

                <TableCell
                  key={item}
                  sx={{
                    backgroundColor:"#0078c9",
                    color:"#fff",
                    fontSize:"12px",
                    fontWeight:600
                  }}
                >
                  {item}
                </TableCell>

              ))}

            </TableRow>

          </TableHead>

          <TableBody>

            {rows.map((row,i)=>(

              <TableRow
                key={i}

                hover

                sx={{
                  "&:hover":{
                    background:"#f5f9ff"
                  }
                }}
              >

                <TableCell>

                  <Checkbox
                    checked={row.status}
                    value={i}
                    onChange={handlestatuslimit}

                    sx={{
                      color:"#0078c9",

                      "&.Mui-checked":{
                        color:"#9e0b22"
                      }
                    }}
                  />

                </TableCell>

                <TableCell
                  sx={{
                    fontSize:"12px",
                    fontWeight:500
                  }}
                >
                  {row.tagname}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize:"12px"
                  }}
                >
                  {row.desc}
                </TableCell>


                <TableCell>

                  {row.isEditMode ? (

                    <Box
                    sx={{
                      display:"flex",
                      gap:.5
                    }}
                    >

                    <IconButton
                    onClick={() =>
                      onToggleEditMode(
                        row.tagname
                      )
                    }

                    sx={{
                      bgcolor:
                      "rgba(0,120,201,.08)",

                      "&:hover":{
                        bgcolor:
                        "rgba(0,120,201,.15)"
                      }
                    }}
                    >
                      <DoneIcon
                      sx={{
                        color:"#0078c9",
                        fontSize:18
                      }}
                      />
                    </IconButton>

                    <IconButton
                    onClick={() =>
                      onRevert(
                        row.tagname
                      )
                    }

                    sx={{
                      bgcolor:
                      "rgba(158,11,34,.08)",

                      "&:hover":{
                        bgcolor:
                        "rgba(158,11,34,.15)"
                      }
                    }}
                    >
                      <CancelIcon
                      sx={{
                        color:"#9e0b22",
                        fontSize:18
                      }}
                      />
                    </IconButton>

                    </Box>

                  ) : (

                    <IconButton
                    onClick={() =>
                      onToggleEditMode(
                        row.tagname
                      )
                    }

                    
                    >
                      <EditIcon
                      sx={{
                        color:"#9e0b22",
                        fontSize:18
                      }}
                      />
                    </IconButton>

                  )}

                </TableCell>


                <CustomTableCell
                  {...{
                    row,
                    name:"lower",
                    onChange
                  }}
                />

                <CustomTableCell
                  {...{
                    row,
                    name:"upper",
                    onChange
                  }}
                />

              </TableRow>

            ))}

          </TableBody>

        </Table>

      </TableContainer>

    </Paper>


    {/* Footer */}

    <Box
      sx={{
        mt:2,
        display:"flex",
        justifyContent:
        "space-between",
        alignItems:"center"
      }}
    >

      <Box>

        {saved && (

          <Alert
            severity="success"

            sx={{
              fontSize:"12px",
              borderRadius:"12px"
            }}
          >
            Limits saved successfully
          </Alert>

        )}

      </Box>


      <Button
        disabled={!props.editAccess}
        onClick={savelimits}
        variant="contained"

        sx={{
          background:"#0078c9",
          height:42,
          px:4,
          fontSize:"12px",

          borderRadius:"12px",

          boxShadow:
          "0px 8px 18px rgba(0,120,201,.25)",

          "&:hover":{
            background:"#0068af"
          }
        }}
      >
        Save Limits
      </Button>

    </Box>

    {getLoader && <GlobalLoader/>}

  </Box>
);
}

export default Limit;
